export default function Footer() {
    return (
        <footer className="footer w-full fixed bottom-0 z-10">
            <div className="w-full px-5">
                2022 © NEXAH.
            </div>
        </footer>
    )
}
